import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/newsService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { convertToHTML, convertFromHTML } from "draft-convert";

import { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

class NewsForm extends Form {
  state = {
    preferredDate: new Date(),
    thumbUrl: "",
    imageUrl: "",
    categories: [
      { id: "default", name: "Default" },
      { id: "sports", name: "Sports" },
      { id: "entertainment", name: "Entertainment" },
      { id: "culture", name: "Culture" },
      { id: "travelling", name: "Travelling" },
    ],
    locations: [
      { id: "default", name: "Default" },
      { id: "popular", name: "Popular" },
      { id: "breaking", name: "Breaking" },
      { id: "featured", name: "Featured" },
      { id: "front", name: "Front" },
    ],
    data: {
      category: "",
      location: "",
      title: "",
      short: "",
      author: "",
    },
    editorState: EditorState.createEmpty(),
    errors: {},
  };

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  schema = {
    id: Joi.string(),
    category: Joi.allow(""),
    location: Joi.allow(""),
    title: Joi.string().required().label("Title"),
    short: Joi.string().required().label("Short"),
    author: Joi.string().required().label("Author"),
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      const text = convertToHTML(this.state.editorState.getCurrentContent());

      let formData = new FormData();
      formData.append(
        "category",
        this.state.data.category == "" ? "default" : this.state.data.category
      );
      formData.append(
        "location",
        this.state.data.location == "" ? "default" : this.state.data.location
      );
      formData.append("title", this.state.data.title);
      formData.append("short", this.state.data.short);
      formData.append("description", text);
      formData.append("author", this.state.data.author);
      formData.append("thumbnail", this.state.thumbUrl);
      formData.append("image", this.state.imageUrl);

      var event = new Date(this.state.preferredDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("news_date", date);

      await saveSingle(formData);

      toast.success("News has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/web/news");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.address)
          errors.address = ex.response.data.errors.address;

        if (ex.response.data.errors.phone)
          errors.phone = ex.response.data.errors.phone;

        if (ex.response.data.errors.account)
          errors.account = ex.response.data.errors.account;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  handleChangePreferredDate = (date) => {
    this.setState({
      preferredDate: date,
    });
  };

  onChangeThumbnail = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ thumbUrl: files[0] });
    //this.createImage(files[0]);
  };

  onChangeImage = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/bank.png";
    const { editorState } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle
          title="Add news"
          icon="tag"
          color="white"
          iconPath={dashboardIcon}
        />
        <center>
          <form
            onSubmit={this.handleSubmit}
            className="ui error form"
            style={{ width: "70%" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">Add news</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderSelect(
                      "category",
                      "Category",
                      this.state.categories
                    )}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderSelect(
                      "location",
                      "Location",
                      this.state.locations
                    )}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("title", "Title", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <label>
                      <b>Short</b>
                    </label>
                    {this.renderTextarea("short", "Short", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <Editor
                      initialEditorState={editorState}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      wrapperStyle={{ height: "auto" }}
                      editorStyle={{
                        height: "400px",
                        border: "1px solid #eeeeee",
                        padding: "7px",
                        paddingTop: "0px",
                      }}
                      toolbarStyle={{}}
                      editorState={editorState}
                      onEditorStateChange={this.onEditorStateChange}
                    />
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("author", "Author", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <label>Thumbnail</label>
                    <input
                      className="input_imagem_artigo"
                      type="file"
                      onChange={this.onChangeThumbnail}
                    />
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <label>Image</label>
                    <input
                      className="input_imagem_artigo"
                      type="file"
                      onChange={this.onChangeImage}
                    />
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16">
                    <label>News Date</label>
                    <br />
                    <DatePicker
                      selected={this.state.preferredDate}
                      onChange={this.handleChangePreferredDate}
                    />
                    <br />
                    <small>(day/month/year)</small>
                  </Table.Cell>
                  <Table.Cell width="16"></Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>
                    {this.renderButton("Save")}
                    <Link to="/web/news" className="ui secondary button">
                      Back
                    </Link>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default NewsForm;
